export const PeoLiveStatusFormField = {
  liveByDefault: 'liveByDefault',
  setAllLive: 'setAllLive',
  liveStatusChanges: 'liveStatusChanges',
} as const;

export const BULK_LOCKED_TOOLTIP = 'Reset or save the Employer changes first';
export const ROW_LOCKED_TOOLTIP = 'Reset or save the bulk change first';
